<script lang="ts">
	import type { Snippet } from 'svelte';

	const {
		children,
		borderBottom,
		borderTop,
		text
	}: { children?: Snippet; borderTop?: boolean; borderBottom?: boolean; text?: string } = $props();

	let borderClasses = $state('');
	if (borderTop) borderClasses += 'border-top ';
	if (borderBottom) borderClasses += 'border-bottom';
</script>

<div class="container {borderClasses}">
	<h2 class="text:headline-large">
		{text}
	</h2>
	{#if children}
		{@render children()}
	{/if}
</div>

<style lang="scss">
	.container {
		display: flex;
		justify-content: space-between;
		align-items: end;
		width: 100%;
	}

	.border-top {
		border-top: $border;
		padding-top: $padding-mini;
		margin-bottom: 66px;
	}

	.border-bottom {
		border-bottom: $border;
		padding-bottom: $padding;
		margin-bottom: $padding-small;
		@include md {
			padding-bottom: $padding-mini;
		}
	}
</style>
